import { render } from "./Head.vue?vue&type=template&id=bd8f4c46&scoped=true"
import script from "./Head.vue?vue&type=script&lang=js"
export * from "./Head.vue?vue&type=script&lang=js"

import "./Head.vue?vue&type=style&index=0&id=bd8f4c46&scoped=true&lang=css"

import exportComponent from "/root/.jenkins/workspace/dev-mdstar-client/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd8f4c46"]])

export default __exports__